import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'

import { Loader2 } from 'lucide-react'

import { RouteErrorComponent } from '@/features/app-shell/route-error-component'
import { Section, SectionTitle } from '@/features/app-shell/section'
import { useHandlePopupCallback } from '@/features/integrations/microsoft-onboarding/hooks/use-handle-popup-callback'
import { microsoftConsentCallbackSearchSchema } from '@/features/integrations/types'

export const Route = createFileRoute('/_dashboard/integrations/new/callback')({
	validateSearch: zodValidator(microsoftConsentCallbackSearchSchema),

	head: () => ({
		meta: [
			{
				title: 'Validating Callback | BitLyft AIR®',
			},
		],
	}),

	component: RouteComponent,
	pendingComponent: RoutePendingComponent,
	errorComponent: RouteErrorComponent,
})

function RouteComponent() {
	const search = Route.useSearch({
		select: (prev) => {
			return microsoftConsentCallbackSearchSchema.parse(prev)
		},
	})

	useHandlePopupCallback(search)

	return (
		<Section>
			<SectionTitle>Validating Callback</SectionTitle>

			<Loader2 className="size-10 animate-spin" />
		</Section>
	)
}

function RoutePendingComponent() {
	return (
		<Section>
			<SectionTitle>Validating Callback</SectionTitle>

			<Loader2 className="size-10 animate-spin" />
		</Section>
	)
}
